import React from 'react';
import { CacheProvider } from './CacheProvider';

export const DashboardProviders = ({ children }: any) => {
    return (
        <CacheProvider>
            {children}
        </CacheProvider>
    );
}